import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'searchClient',
})
export class SearchClientPipe implements PipeTransform {
	transform(value: any[], arg: any): any {
		if (value !== undefined) {
			const result = [];
			for (const client of value) {
				if (client.name.toLowerCase().indexOf(arg.toLowerCase()) > -1) {
					result.push(client);
				}
			}
			return result;
		}
	}
}
